import React from 'react';
import { Container, Row, Col } from 'react-grid-system';
import { MDXRenderer } from 'gatsby-plugin-mdx';
import { useStaticQuery } from 'gatsby';
import Img from 'gatsby-image';
import LegalSidebar from '@interness/web-core/src/components/templates/LegalSidebar/LegalSidebar';
import Wrapper from '@interness/web-core/src/components/structure/Wrapper/Wrapper';
import SEO from '@interness/web-core/src/components/modules/SEO/SEO';
import Spacer from '@interness/web-core/src/components/structure/Spacer/Spacer';
import MoreExpander from '@interness/web-core/src/components/structure/MoreExpander/MoreExpander';
import InfoBlock from '@interness/web-core/src/content/legal/InfoBlock';
import InternessLogo from '@interness/web-core/src/content/InternessLogo';
import { jsx as ___EmotionJSX } from "@emotion/react";
const LegalPage = props => {
  const mapping = {
    impressum: 'eRecht24Imprint',
    datenschutz: 'eRecht24PrivacyPolicy'
  };
  const legalData = props.data[mapping[props.pageContext.legalType]];
  const data = useStaticQuery("1980251694");
  function filterByName(nodes, nameToFind) {
    return nodes.find(node => node.name === nameToFind);
  }

  // const MAILJET_SECTION = `
  //   <h4>E-Mail-Versand über Mailjet</h4>
  //   <p>Wir nutzen den Dienst „Mailjet“ (Mailgun Technologies SAS, 13-13 bis, rue de l’Aubrac – 75012 Paris, Frankreich) zum Versand von E-Mails über unser Kontaktformular. Wenn Sie das Kontaktformular nutzen, wird Ihre Nachricht per E-Mail an uns weitergeleitet. Dazu werden Ihr Name, Ihre E-Mail-Adresse und Ihre Nachricht über die Server von Mailjet verarbeitet. Die Verarbeitung erfolgt auf Grundlage unseres berechtigten Interesses (Art. 6 Abs. 1 lit. f DSGVO) an einer zuverlässigen Kommunikation mit unseren Nutzern.</p>
  //   <p>Weitere Informationen finden Sie in der Datenschutzerklärung von Mailjet:
  //   <a href="https://www.mailjet.com/legal/privacy-policy" target="_blank" rel="nofollow noopener noreferrer external">Mailjet Datenschutzerklärung</a></p>
  // `;
  //
  // const modifiedLegalData = legalData.html_de.replace(/(<h3>Kontaktformular<\/h3>)/, `$1${MAILJET_SECTION}`);

  const imprintImageDark = filterByName(data.allFile.nodes, 'impressum-siegel-dark-horizontal-large');
  const imprintImageLight = filterByName(data.allFile.nodes, 'impressum-siegel-light-horizontal-large');
  const privacyImageDark = filterByName(data.allFile.nodes, 'datenschutz-siegel-dark-horizontal-large');
  const privacyImageLight = filterByName(data.allFile.nodes, 'datenschutz-siegel-light-horizontal-large');
  if (legalData) {
    return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(SEO, {
      title: props.data.mdx.frontmatter.title
    }), ___EmotionJSX(Wrapper, null, ___EmotionJSX(Spacer, null), process.env.NODE_ENV === 'development' && legalData.warnings && ___EmotionJSX(React.Fragment, null, ___EmotionJSX(MoreExpander, {
      title: "Warnungen (nur in Entwicklung sichtbar)"
    }, ___EmotionJSX("div", {
      style: {
        backgroundColor: '#e74c3c',
        color: '#fff',
        padding: '40px'
      },
      dangerouslySetInnerHTML: {
        __html: legalData.warnings
      }
    })), ___EmotionJSX(Spacer, null)), ___EmotionJSX("div", {
      dangerouslySetInnerHTML: {
        __html: legalData.html_de
      }
    }), ___EmotionJSX(InfoBlock, {
      id: "rolex"
    }), props.pageContext.legalType === 'datenschutz' && ___EmotionJSX(React.Fragment, null, ___EmotionJSX(InfoBlock, {
      id: "consentmanager"
    }), ___EmotionJSX(Img, {
      fixed: privacyImageDark.childImageSharp.fixed,
      alt: "E-Recht24 Siegel"
    })), props.pageContext.legalType === 'impressum' && ___EmotionJSX(React.Fragment, null, ___EmotionJSX(InfoBlock, {
      id: "additional_top_info"
    }), ___EmotionJSX(InfoBlock, {
      id: "additional_bottom_info"
    }), ___EmotionJSX(InfoBlock, {
      id: "image_sources"
    }), ___EmotionJSX(InfoBlock, {
      id: "insurance"
    }), ___EmotionJSX(InfoBlock, {
      id: "legal_authority"
    }), ___EmotionJSX("h3", null, "Umsetzung und Unterst\xFCtzung"), ___EmotionJSX(InternessLogo, null), ___EmotionJSX("h3", null, "E-Recht24"), ___EmotionJSX(Img, {
      fixed: imprintImageDark.childImageSharp.fixed,
      alt: "E-Recht24 Siegel"
    }))));
  } else {
    return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(SEO, {
      title: props.data.mdx.frontmatter.title
    }), ___EmotionJSX(Wrapper, null, ___EmotionJSX(Spacer, null), ___EmotionJSX(Container, {
      fluid: true
    }, ___EmotionJSX(Row, null, ___EmotionJSX(Col, {
      md: 4
    }, ___EmotionJSX(LegalSidebar, null)), ___EmotionJSX(Col, {
      md: 8
    }, ___EmotionJSX("h1", null, props.data.mdx.frontmatter.title), ___EmotionJSX(MDXRenderer, null, props.data.mdx.body))))));
  }
};
export default LegalPage;